import APIOffers from "@/api/modules/offers";

const state = () => ({
  offersList: {
    offers: [],
    meta: {}
  },
  offer: {},
  offerRaw: {}
});

export default {
  namespaced: true,
  state,
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    }
  },
  actions: {
    getOffersList({ commit }, params) {
      return APIOffers.getOffersList(params).then(response => {
        commit("SET_DATA", { type: "offersList", data: response.data });
      });
    },
    getOffer({ commit }, id) {
      return APIOffers.getOffer(id).then(response => {
        if (response && response.data) {
          commit("SET_DATA", { type: "offer", data: response.data.offer });
          commit("SET_DATA", { type: "offerRaw", data: response.data.offer });
        }
      });
    },
    createOffer(_, payload) {
      return APIOffers.createOffer(payload);
    },
    updateOffer({ state }, { id, patch }) {
      const raw = state.offerRaw;

      // Helper: deep-merge a translatable field.
      // Takes all existing lang values from raw (including ua/es/kz/etc.)
      // and overrides only with what our form sends (en/ru/uk/de/fr/tr/ar/pl).
      const mergeText = (rawKeys, formValue) => {
        let base = {};
        for (const key of rawKeys) {
          if (raw[key] && typeof raw[key] === "object") {
            base = { ...raw[key] };
            break;
          }
        }
        return { ...base, ...formValue };
      };

      const payload = {
        // Full raw offer preserves: clinic, illnesses, operations, doctors,
        // currency, specialPrice, packagePrice, services, etc.
        ...raw,

        // Settings override
        type:        patch.type,
        level:       patch.level,
        is_hide:     patch.is_hide,
        tags:        patch.tags,
        template_id: patch.template_id,
        packagePrice: patch.packagePrice,
        currency:     patch.currency,
        operations: patch.operations,
        illnesses:  patch.illnesses,

        // Text fields: deep merge raw (all langs) + form (8 langs)
        name:                  mergeText(["name"],                                          patch.name),
        forWho:                mergeText(["forWho", "for_who"],                             patch.for_who),
        for_who:               mergeText(["forWho", "for_who"],                             patch.for_who),
        duration:              mergeText(["duration"],                                      patch.duration),
        procedureDescription:  mergeText(["procedureDescription", "procedure_description"], patch.procedure_description),
        procedure_description: mergeText(["procedureDescription", "procedure_description"], patch.procedure_description),
        accommodation:         mergeText(["accommodation"],                                 patch.accommodation),
        transport:             mergeText(["transport"],                                     patch.transport),
        otherServices:         mergeText(["otherServices", "other_services"],               patch.other_services),
        other_services:        mergeText(["otherServices", "other_services"],               patch.other_services),
        postOperationCare:     mergeText(["postOperationCare", "post_operationCare"],       patch.post_operation_care),
        post_operationCare:    mergeText(["postOperationCare", "post_operationCare"],       patch.post_operation_care),
        implant:               mergeText(["implant"],                                       patch.implant),
        promo_description:     mergeText(["promo_description"],                             patch.promo_description),

        // Services override (only if patch explicitly sent the field)
        ...(Array.isArray(patch.services) ? { services: patch.services } : {})
      };

      return APIOffers.updateOffer(id, payload);
    },
    deleteOffer(_, id) {
      return APIOffers.deleteOffer(id);
    },
    setScore(_, { id, score }) {
      return APIOffers.setScore(id, score);
    }
  }
};
